export default {
  data() {
    return { useraccess: [] }
  },
  methods:{
    hasPermissionFor(_reqPermissions) {
      const permissions = typeof _reqPermissions === 'string' ? [_reqPermissions] : _reqPermissions;
      return permissions.reduce( (acc, v) => this.useraccess.includes(v) && acc, true)
    }
  },
  mounted() {
    const permissions = JSON.parse(localStorage.getItem('pogs-user-permissions'));
    this.useraccess = permissions ? permissions : []
  }
}

